import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ParlonsDeVotreProjet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="parlons-de-votre-projet" className="relative w-full min-h-[400px] flex items-center justify-center overflow-hidden bg-secondary !h-[600px]">
      {}
      <div className="absolute inset-0 !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/04/gallery_spa_bathroom.webp)] bg-cover bg-center grayscale opacity-70" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight drop-shadow-lg max-w-4xl mx-auto leading-tight">Votre projet mérite une équipe rigoureuse et expérimentée</h1>
      </div>
    </section>;
}